// extracted by mini-css-extract-plugin
module.exports = {"title":"ProductSidePaneLayout_title__o7Syo","modal":"ProductSidePaneLayout_modal__OJE4t","footer":"ProductSidePaneLayout_footer__kdYpK"};